import React from 'react';
import { motion } from 'framer-motion';
import { Printer } from 'lucide-react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b-4 border-black" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-61">
        <div className="flex items-center gap-2" data-id="element-62">
          <Printer className="w-8 h-8" strokeWidth={2.5} data-id="element-63" />
          <span className="font-display font-bold text-2xl tracking-wider uppercase" data-id="element-64">
            STRATA CREATIVE GROUP
          </span>
        </div>
        <motion.button onClick={() => document.getElementById('quote-form')?.scrollIntoView({
        behavior: 'smooth'
      })} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="bg-black text-white px-6 py-2.5 font-display font-bold uppercase tracking-widest text-sm hover:bg-neutral-800 transition-colors" data-id="element-65">
          Get a Fast Quote
        </motion.button>
      </div>
    </header>;
}